var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationsUnread = function SvgNotificationsUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 18h4q0 .824-.588 1.413A1.93 1.93 0 0 1 8 20m-8-3v-2h2V8q0-2.075 1.25-3.687Q4.5 2.7 6.5 2.2v-.7q0-.625.438-1.062A1.45 1.45 0 0 1 8 0q.624 0 1.063.438Q9.5.874 9.5 1.5v.325a4.606 4.606 0 0 0-.5 2.3q-.25-.05-.488-.088A3 3 0 0 0 8 4Q6.35 4 5.175 5.175T4 8v7h8V8.575A5 5 0 0 0 14 9v6h2v2zM14 7a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 11 4q0-1.25.875-2.125A2.9 2.9 0 0 1 14 1q1.25 0 2.125.875T17 4t-.875 2.125A2.9 2.9 0 0 1 14 7"
  })));
};
export default SvgNotificationsUnread;